module.exports = __webpack_public_path__ + "img/trip_sendai12.5158a54a.jpg";